import React, { useEffect, useState } from 'react'
import {
  Button,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField
} from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS } from 'asterX-UI'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { KzIcon, LockedIcon, RuIcon } from 'asterX-UI/Icons'
import ClientNeedsModal from 'pages/Desktop/Selection/Manager/components/ClientNeedsModal'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import CheckBoxBtn from 'asterX-UI/Inputs/CheckBoxBtn'
import { LANGUAGES } from 'constants/client'
import ClientHistory from 'pages/Desktop/Selection/Manager/components/ClientHistory'
import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'

const useStyles = makeStyles(theme => ({
  header: {
    padding: 4,
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600
  },
  rootDiv: {
    display: 'flex',
    gap: 32,
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  seoData: { width: '100%', display: 'flex', flexDirection: 'column', gap: 16 },
  cardDiv: {
    display: 'flex',
    padding: '24px 16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 20,
    borderRadius: 12,
    backgroundColor: BASE_COLORS.White
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center'
  },
  iconedCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    gap: 8
  }
}))

const NewWL = () => {
  const classes = useStyles()
  const {
    store: { seoClient, seoLoading, sale },
    funcs: {
      onChangeSeoClientFields,
      reAssignActiveSale,
      createSale,
      updateStatusTrack
    }
  } = useSelectionStore()
  const [isNeedsOpen, setIsNeedsOpen] = useState(false)
  const [lockPhone, setLockPhone] = useState(false)
  const isValidPhone =
    seoClient?.phoneNumber?.toString()?.forMaskPhone() && lockPhone
  const handleClose = () => {
    setIsNeedsOpen(false)
  }

  const handleOpen = () => {
    setIsNeedsOpen(true)
    if (sale?.saleStatusTrack?.code !== '130') {
      updateStatusTrack(130)
    }
  }

  const onChange = ({ target }) => {
    const { name, value } = target
    if (name === 'phoneNumber') {
      if (value?.toString()?.forMaskPhone()) {
        setLockPhone(true)
        reAssignActiveSale(value?.toString()?.forMaskPhone())
        return onChangeSeoClientFields({
          [name]: value?.toString()?.forMaskPhone()
        })
      }
      return onChangeSeoClientFields({
        [name]: value.toString().toNum()
      })
    }
    onChangeSeoClientFields({
      [name]: value
    })
  }
  const onUnlockPhone = () => {
    setLockPhone(false)
    onChangeSeoClientFields({
      phoneNumber: '',
      firstName: '',
      language: ''
    })
  }

  useEffect(() => {
    if (sale?.saleStatusTrack?.code === '130') {
      setIsNeedsOpen(true)
    }
  }, [sale?.saleStatusTrack?.code])

  const lockAdornment = (
    <InputAdornment position="start">
      <IconButton size={'small'} onClick={onUnlockPhone}>
        <LockedIcon />
      </IconButton>
    </InputAdornment>
  )
  return isNeedsOpen ? (
    <ClientNeedsModal handleClose={handleClose} onSave={createSale} />
  ) : (
    <PageContainerMobile
      customHeader={<div className={classes.header}>Новый подбор</div>}
    >
      <LoaderBackdrop loading={seoLoading} />
      <div className={classes.rootDiv}>
        <div className={classes.seoData}>
          <div className={classes.cardDiv}>
            <MaskedTextInput
              label={'Телефон'}
              fullWidth
              required
              name={'phoneNumber'}
              mask={'7 (999) 999-99-99'}
              disabled={lockPhone}
              value={seoClient?.phoneNumber}
              onChange={onChange}
              InputProps={{
                endAdornment: lockPhone && lockAdornment
              }}
            />
            {isValidPhone && (
              <>
                <TextField
                  label={'Имя'}
                  fullWidth
                  required
                  value={seoClient?.firstName}
                  onChange={onChange}
                  name={'firstName'}
                />

                <div
                  className={classes.row}
                  style={{
                    marginTop: 20,
                    width: '100%',
                    justifyContent: 'space-between'
                  }}
                >
                  <CheckBoxBtn
                    checked={seoClient?.language === LANGUAGES[1].code}
                    name={'language'}
                    onClick={({ target }) =>
                      onChangeSeoClientFields({
                        [target.name]: LANGUAGES[1].code
                      })
                    }
                  >
                    <div className={classes.iconedCheckbox}>
                      <RuIcon />
                      Русский
                    </div>
                  </CheckBoxBtn>
                  <CheckBoxBtn
                    checked={seoClient?.language === LANGUAGES[0].code}
                    name={'language'}
                    onClick={({ target }) =>
                      onChangeSeoClientFields({
                        [target.name]: LANGUAGES[0].code
                      })
                    }
                  >
                    <div className={classes.iconedCheckbox}>
                      <KzIcon />
                      Қазақша
                    </div>
                  </CheckBoxBtn>
                </div>
              </>
            )}
          </div>
          {isValidPhone && (
            <>
              <div className={classes.row}>
                <Button
                  variant={'contained'}
                  size={'small'}
                  color={'primary'}
                  fullWidth
                  disabled={!seoClient?.firstName}
                  onClick={() => handleOpen()}
                >
                  Начать подбор авто
                </Button>
              </div>{' '}
            </>
          )}
        </div>
        {isValidPhone && <ClientHistory phone={seoClient?.phoneNumber} />}
      </div>
    </PageContainerMobile>
  )
}
export default NewWL
